<template>
    <!--<div>-->
        <!--<div v-if="isShowCustomTool"></div>-->
    <!--</div>-->
    <div class="code" :class="{ 'toggled': menuToggledSidebar }">
        <div
            id="controller-nipple-left"
            class="position-absolute game-controller__nipple-wrapper"
            v-show="!!isJoyStick"
        ></div>
        <div
            id="controller-nipple-right"
            class="position-absolute game-controller__nipple-wrapper"
            v-show="!!isJoyStick"
        ></div>
        <div class="game-controller__wrapper" :class="{'d-flex': isJoyStick, 'd-none': !isJoyStick}">

            <div class="game-controller__panel">
                <span>{{$t('translation.joyStick')}}</span>

                <!--  FIXME: remove after test -->
                <template>

                    <span class="small mx-1" style="font-size: 14px;">{{ joyStickCurrentAction }}</span>
                    <span>
                        <button
                            @click="turnJoystickLightOn"
                            class="btn btn-primary btn-sm"
                            :disabled="isLightIndicatorOn"
                        >
                            ON
                        </button>
                        <button
                            @click="turnJoystickLightOff"
                            class="btn btn-primary btn-sm"
                            :disabled="!isLightIndicatorOn"
                        >
                            OFF
                        </button>
                    </span>
                </template>
            </div>
            <div
                id="game-controller"
                class="game-controller__joystick"
            >
                <button
                    class="Js-button Js-button-X"
                    @touchstart.prevent="callJoystickButtonAction(6, 'pressed')"
                    @touchend="callJoystickButtonAction(6, 'released')"
                    @mousedown="callJoystickButtonAction(6, 'pressed')"
                    @mouseup="callJoystickButtonAction(6, 'released')"
                ></button>
                <button
                    class="Js-button Js-button-circle"
                    @touchstart.prevent="callJoystickButtonAction(8, 'pressed')"
                    @touchend="callJoystickButtonAction(8, 'released')"
                    @mousedown="callJoystickButtonAction(8, 'pressed')"
                    @mouseup="callJoystickButtonAction(8, 'released')"
                ></button>
                <button
                    class="Js-button Js-button-triangle"
                    @touchstart.prevent="callJoystickButtonAction(5, 'pressed')"
                    @touchend="callJoystickButtonAction(5, 'released')"
                    @mousedown="callJoystickButtonAction(5, 'pressed')"
                    @mouseup="callJoystickButtonAction(5, 'released')"
                ></button>
                <button
                    class="Js-button Js-button-square"
                    @touchstart.prevent="callJoystickButtonAction(7, 'pressed')"
                    @touchend="callJoystickButtonAction(7, 'released')"
                    @mousedown="callJoystickButtonAction(7, 'pressed')"
                    @mouseup="callJoystickButtonAction(7, 'released')"
                ></button>
                <button
                    class="Js-button Js-button-F1"
                    @touchstart.prevent="callJoystickButtonAction(9, 'pressed')"
                    @touchend="callJoystickButtonAction(9, 'released')"
                    @mousedown="callJoystickButtonAction(9, 'pressed')"
                    @mouseup="callJoystickButtonAction(9, 'released')"
                ></button>
                <button
                    class="Js-button Js-button-F2"
                    @touchstart.prevent="callJoystickButtonAction(10, 'pressed')"
                    @touchend="callJoystickButtonAction(10, 'released')"
                    @mousedown="callJoystickButtonAction(10, 'pressed')"
                    @mouseup="callJoystickButtonAction(10, 'released')"
                ></button>
                <button
                    @touchstart.prevent="callJoystickButtonAction(11, 'pressed')"
                    @touchend="callJoystickButtonAction(11, 'released')"
                    @mousedown="callJoystickButtonAction(11, 'pressed')"
                    @mouseup="callJoystickButtonAction(11, 'released')"
                    class="Js-button Js-button-turn-on"
                ></button>
                <div
                    class="Js-indicator"
                    :class="{
                        'Js-indicator--green': isLightIndicatorOn,
                        'Js-indicator--red': !isLightIndicatorOn,
                    }"
                >
                </div>
                <button
                    class="Js-button Js-button-down"
                    @touchstart.prevent="callJoystickButtonAction(2, 'pressed')"
                    @touchend="callJoystickButtonAction(2, 'released')"
                    @mousedown="callJoystickButtonAction(2, 'pressed')"
                    @mouseup="callJoystickButtonAction(2, 'released')"
                ></button>
                <button
                    class="Js-button Js-button-right"
                    @touchstart.prevent="callJoystickButtonAction(4, 'pressed')"
                    @touchend="callJoystickButtonAction(4, 'released')"
                    @mousedown="callJoystickButtonAction(4, 'pressed')"
                    @mouseup="callJoystickButtonAction(4, 'released')"
                ></button>
                <button
                    class="Js-button Js-button-up"
                    @touchstart.prevent="callJoystickButtonAction(1, 'pressed')"
                    @touchend="callJoystickButtonAction(1, 'released')"
                    @mousedown="callJoystickButtonAction(1, 'pressed')"
                    @mouseup="callJoystickButtonAction(1, 'released')"
                ></button>
                <button
                    class="Js-button Js-button-left"
                    @touchstart.prevent="callJoystickButtonAction(3, 'pressed')"
                    @touchend="callJoystickButtonAction(3, 'released')"
                    @mousedown="callJoystickButtonAction(3, 'pressed')"
                    @mouseup="callJoystickButtonAction(3, 'released')"
                ></button>
                <div
                    class="nipple-inside nipple-inside--right"
                ></div>

                <div
                    class="nipple-inside nipple-inside--left"
                ></div>
            </div>
        </div>
        <div class="code__menu">
            <sidebar-menu
                :download="download"
                @open-file="openFile"
                @go-to-homepage="goToHomepage"
                @toggle-menu="toggleMenu()"
            />
        </div>
        <div
            class="code__field"
            :class="{
                'workspace-properties-opened': isShowProperties && !menuRightBarIsOpen,
            }"
        >
            <!--<div class="container-fluid">-->
                <div id="blocks">
                    <div class="code__edit-controls">
                        <template v-if="authCurrentDirection === 'ltr'">
                            <button @click="undo" class="code__edit-undo" type="button" />
                            <button @click="redo" class="code__edit-redo" type="button" />
                        </template>
                        <template v-else>
                            <button @click="undo" class="code__edit-redo" type="button" />
                            <button @click="redo" class="code__edit-undo" type="button" />
                        </template>


                        <button @click="newFile" class="code__edit-new-file" type="button" />
                    </div>
                </div>
                <!--<button type="button" @click="getCode">&gt;</button>-->
            <!--</div>-->
        </div>
        <div class="code__right-bar">
            <right-bar
                @activejoystick="isJoyStick = !isJoyStick"
                :showJoyStickSidebarIcon="isShowJoyStickSidebarIcon"
            />
            <settings
                @change-background-color="changeBackgroundColor"
                @change-lavel="changeToolbox"
                :is-default-nipple-active="!isLeftNippleLocked"
                :show-joystick-settings="isShowJoyStickSidebarIcon"
                :level="curentLevel"
                :show-levels="showLevels"
                :download="download"
                v-if="menuSettings"
            />
            <communication v-if="menuCommunication" />
            <source-code :code="code" v-if="menuSourceCode" />
            <online v-if="menuOnline" />
            <help v-if="menuHelp" />
        </div>
        <div v-click-outside="hideProperties" v-if="isShowProperties" class="code__preferences">
            <properties
                :block-id="blockId"
                :fieldName="currentFieldName"
                :workspace="workspace"
                :toolbox="workspaceLevel"
                :level="curentLevel - 1"
                v-model="xmlWorkspace"
            />
        </div>
    </div>
</template>

<script>
    import { saveAs } from 'file-saver';
    import * as detector from 'detect-browser';

    import menuMixin from '../mixins/menu';
    import authMixin from '../mixins/auth';
    import topicMixin from '../mixins/topic';
    import SidebarMenu from '../components/Code/sidebar/SidebarMenu.vue';
    import RightBar from '../components/Code/rightbar/RightBar.vue';
    import Settings from '../components/Code/rightbar/Settings.vue';
    import Communication from '../components/Code/rightbar/Communication.vue';
    import SourceCode from '../components/Code/rightbar/SourceCode.vue';
    import Online from '../components/Code/rightbar/Online.vue';
    import Help from '../components/Code/rightbar/Help.vue';
    import Properties from '../components/Code/properties/Properties.vue';
    import ClickOutside from '../plugins/ClickOutside';

    import emitResize from '../utils/emitResize';

    export default {
        metaInfo() {
            return {
                title: this.$t('translation.workspace'),
            };
        },
        directives: {
            ClickOutside,
        },
        components: {
            SidebarMenu,
            RightBar,
            Settings,
            Communication,
            SourceCode,
            Online,
            Help,
            Properties,
        },
        mixins: [
            menuMixin,
            authMixin,
            topicMixin,
        ],
        data() {
            return {
                isLightIndicatorOn: false,
                isLeftNippleLocked: false,
                isRightNippleLocked: true,
                isJoyStick: false,
                isShowJoyStickSidebarIcon: true,
                leftNipple: null,
                rightNipple: null,
                joyStickCurrentAction: '',
                browser: detector.detect(),
                isShowCustomTool: false,
                workspace: null,
                isShowProperties: false,
                showLevels: true,
                blockId: '',
                xmlWorkspace: '<xml xmlns="http://www.w3.org/1999/xhtml"></xml>',
                curentLevel: 1,
                currentFieldName: '',
                code: '',
                startBlock: `<xml id="startBlocks"><block type="start" inline="false" x="320" y="50"></block></xml>`,
                download: '<xml xmlns="http://www.w3.org/1999/xhtml"></xml>',
                workspaceLevel: [
                      `<xml>
                        <category name="%{BKY_KORIL_MOVEMENT}" icon="output-icon">
                          <label text="%{BKY_KORIL_MOVEMENT}"></label>
                          <block type="koril_lvl1_setup_speed"></block>
                          <block type="koril_lvl1_drive_forward"></block>
                          <block type="koril_lvl1_drive_backward"></block>
                          <block type="koril_lvl1_drive_left"></block>
                          <block type="koril_lvl1_drive_right"></block>
                          <block type="koril_lvl1_drive_stop"></block>
                        </category>
                        <category name="%{BKY_KORIL_SENSORS}" icon="output-icon">
                        <label text="%{BKY_KORIL_SENSORS}"></label>
                          <block type="koril_lvl1_BTcontroller"></block>
                          <block type="koril_lvl1_touch_on"></block>
                          <block type="koril_lvl1_touch_off"></block>
                          <block type="koril_lvl1_ir_on"></block>
                          <block type="koril_lvl1_ir_off"></block>
                        </category>
						<category name="Display" icon="output-icon">
                        <label text="Display"></label>
                          <block type="koril_lvl1_displayimage" custom-data='{"images_LIST": {"en": "image","he": "תמונה"}}'></block>
                        </category>
						<category name="Sound" icon="output-icon">
                        <label text="Sound"></label>
                          <block type="koril_lvl1_playsoundCartoon" custom-data='{"soundfile_SOUNDLIST": {"en": "Sound file","he": "קובץ קול"}}'></block>
                        </category>
                        <category name="%{BKY_KORIL_TIMING}" icon="output-icon">
                        <label text="%{BKY_KORIL_TIMING}"></label>
                          <block type="koril_lvl1_delay" custom-data='{"seconds_LIST": {"en": "Seconds","he": "שניות"}}'></block>
                        </category>
                        <category name="%{BKY_KORIL_LOOPS}" icon="output-icon">
                        <label text="%{BKY_KORIL_LOOPS}"></label>
                          <block type="koril_lvl1_forever"></block>
                        </category>
                    </xml>`,
                    `<xml>
                        <category name="%{BKY_KORIL_MOVEMENT}" icon="output-icon">
                            <label text="%{BKY_KORIL_MOVEMENT}"></label>
                          <block type="koril_lvl2_dc_motor" custom-data='{"motorport_RADIO": {"en": "Motor Port","he": "כניסת המנוע"},"direction_SWITCH": {"en": "Spin Direction","he": "כיוון הסיבוב"},"speed_SLIDER_0_10_1": {"en": "Speed","he": "מהירות"}}'></block>
                        </category>
                        <category name="%{BKY_KORIL_OUTPUT}" icon="output-icon">
                       <label text="%{BKY_KORIL_OUTPUT}"></label>
                          <block type="koril_lvl2_rgbled" custom-data='{"port_RADIO": {"en": "Port","he": "יציאה"}, "color_COLOUR": {"en": "Color","he": "צבע"}}'></block>
                          <block type="koril_lvl2_delay" custom-data='{"sec_LIST": {"en": "Seconds","he": "שניות"}, "msec_SLIDER_0_1000_50": {"en": "Milliseconds","he": "מילישניות"}}'></block>
					      <block type="koril_lvl2_write_terminal" custom-data='{"data_INPUTBOX": {"en": "Text to write","he": "טקסט לרישום"}}'></block>
                          <block type="koril_lvl2_writelcd"></block>
                          <block type="koril_lvl2_writesensor2lcd"></block>
                     	</category>
                        <category name="%{BKY_KORIL_INPUT}" icon="input-icon">
                        <label text="%{BKY_KORIL_INPUT}"></label>
						  <block type="koril_lvl2_remotecontroler"></block>
						  <block type="koril_lvl2_if_touch" custom-data='{"port_RADIO": {"en": "Input Port","he": "כניסה"}, "state_SWITCH": {"en": "State","he": "מצב"}}'></block>
                          <block type="koril_lvl2_if_us" custom-data='{"port_RADIO": {"en": "Input Port","he": "כניסה"}, "cm_SLIDER_0_300_1": {"en": "Distance in Centimeters","he": "מרחק בסנטימטרים"}}'></block>
                          <block type="koril_lvl2_if_ir" custom-data='{"port_RADIO": {"en": "Input Port","he": "כניסה"}, "state_SWITCH": {"en": "State","he": "מצב"}, "threshold_SLIDER_0_1024_1": {"en": "Threshold","he": "ערך סף"}}'></block>
                        </category>
                        <category name="%{BKY_KORIL_LOOPS}" icon="loops-icon">
                        <label text="Loops"></label>
                          <block type="koril_lvl2_forever"></block>
                          <block type="koril_lvl2_controls_repeat">
                            <value name="TIMES">
                              <shadow type="math_number">
                                <field name="NUM">10</field>
                              </shadow>
                            </value>
                          </block>
                          <block type="koril_lvl2_break"></block>
					      <block type="koril_lvl2_remark" custom-data='{"REMARK_INPUTBOX": {"en": "Remark","he": "הערה"}}'></block>
                        </category>
                    </xml>`,
                    `<xml>
                        <category name="colour" icon="colour-icon">
                            <label text="colour"></label>
                            <block type="colour_picker"></block>
                        </category>
                    </xml>`,
                    `<xml>
                        <category name="logical" icon="logic-icon">
                            <label text="logic"></label>
                            <block type="controls_if"></block>
                            <block type="logic_compare"></block>
                            <block type="logic_operation"></block>
                            <block type="logic_negate"></block>
                            <block type="logic_boolean"></block>
                            <block type="logic_null"></block>
                            <block type="logic_ternary"></block>
                        </category>
                    </xml>`,
                    `<xml>
                        <category name="colour" icon="colour-icon">
                            <label text="colour"></label>
                            <block type="colour_picker"></block>
                        </category>
                       <category name="Input" icon="input-icon">
                          <block type="all_custom_block"></block>
                          <block type="two_custom_block"></block>
                          <block type="two_custom_block_inputbox"></block>
                        </category>
                    </xml>`,
                    `<xml>
                        <category name="Input" icon="input-icon">
                          <block type="all_custom_block"></block>
                          <block type="two_custom_block"></block>
                          <block type="two_custom_block_inputbox"></block>
                        </category>
                    </xml>`,
                ],
            };
        },
        methods: {
            hideRightBar() {
                this.$store.dispatch('menu/closeAll');
                emitResize();
            },
            hideProperties() {
                this.isShowProperties = false;
                emitResize();
            },
            getCode() {
                // console.log(Blockly.Arduino.workspaceToCode(this.workspace));
            },
            eventBlockly(event) {
                if (event.element === 'click-input') {
                    if (event.fieldName !== undefined) {
                        const isGaugeSlider = event.fieldName.split('_')[1] === 'GAUGE';
                        const isInputBox = event.fieldName.split('_')[1] === 'INPUTBOX';
                        const isSlider = event.fieldName.split('_')[1] === 'SLIDER';
                        const isColor = event.fieldName.split('_')[1] === 'COLOUR';
                        const isSoundList = event.fieldName.split('_')[1] === 'SOUNDLIST';
                        const isImageList = event.fieldName.split('_')[1] === 'IMGLIST';
                        const isRadioList = event.fieldName.split('_')[1] === 'RADIO';
                        const isSwitchList = event.fieldName.split('_')[1] === 'SWITCH';
                        const isBasicList = event.fieldName.split('_')[1] === 'LIST';

                        if (isGaugeSlider
                            || isInputBox
                            || isColor
                            || isSoundList
                            || isImageList
                            || isRadioList
                            || isSwitchList
                            || isBasicList
                            || isSlider) {
                            this.isShowProperties = true;
                            emitResize();
                            this.blockId = event.blockId;
                            this.currentFieldName = event.fieldName;

                            const timer = setTimeout(() => {
                                this.xmlWorkspace = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace));
                                clearTimeout(timer);
                            }, 300);
                        }
                    }
                }

                if (event.element === 'click' || event.element === 'click-input') {
                    if (document.getElementById('help-iframe') !== null) {
                        document.getElementById('help-iframe').contentWindow
                            .scrollToBlock(`#${this.workspace.getBlockById(event.blockId).type}`);
                    }
                }

                this.download = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace));

                try {
                    this.code = Blockly.KorilScript.workspaceToCode(this.workspace);
                } catch (e) {
                    console.error(e);
                }
            },
            changeToolbox(level) {
                this.curentLevel = level;
                this.workspace.updateToolbox(this.workspaceLevel[this.curentLevel - 1]);
                window.$('.blocklyFlyout').css({ 'display': 'none' });
                window.$('.blocklyFlyoutScrollbar').attr('display', 'none');
            },
            openFile(content) {
                this.workspace.clear();
                let xml = Blockly.Xml.textToDom(content);
                Blockly.Xml.domToWorkspace(xml, this.workspace);
            },
            goToHomepage() {
                if (this.$route.params.topicId && this.topicTopic.lesson_id && this.topicTopic.lesson.course_id) {
                    this.$router.push({
                        name: 'topic',
                        params: {
                            course_id: this.topicTopic.lesson.course_id,
                            lesson_id: this.topicTopic.lesson_id,
                            topic_id: this.$route.params.topicId,
                        },
                    });
                } else {
                    const routerName = window.getAppStorage('from_page');

                    window.removeAppStorage('from_page');

                    this.$router.push({
                        name: routerName || 'home',
                    });
                }
            },
            newFile() {
                window.Swal({
                    title: this.$t('translation.doYouWantSave'),
                    type: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: this.$t('translation.yes'),
                    cancelButtonText: this.$t('translation.no'),
                }).then((result) => {
                    if (result.value) {
                        try {
                            // jsBridge.saveFile(this.download);

                            console.log('save');
                            window.invokeCSCode('save');
                        } catch (e) {
                            let blob = new Blob([this.download], {
                                type: 'text/plain;charset=utf-8',
                            });

                            saveAs(blob, "golanix.glx");
                        }

                        this.workspace.clear();
                        Blockly.Xml.domToWorkspace(Blockly.Xml.textToDom(this.startBlock), this.workspace);
                        this.workspace.clearUndo();

                        try {
                            console.log('new-file');
                            window.invokeCSCode('new-file');
                        } catch (e) {
                            // Handle error
                        }
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        this.workspace.clear();
                        Blockly.Xml.domToWorkspace(Blockly.Xml.textToDom(this.startBlock), this.workspace);
                        this.workspace.clearUndo();

                        try {
                            console.log('new-file');
                            window.invokeCSCode('new-file');
                        } catch (e) {
                            // Handle error
                        }
                    }
                });

            },
            showHelp(blockInstance) {
                this.menuHelp = true;
                this.isShowProperties = false;

                const timer = setTimeout(() => {
                    if (document.getElementById('help-iframe') !== null) {
                        document.getElementById('help-iframe').contentWindow.scrollToBlock(`#${blockInstance.type}`);
                    }

                    clearTimeout(timer);
                }, 500);
            },
            undo() {
              this.workspace.undo();
              this.xmlWorkspace = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace));
            },
            redo() {
              this.workspace.undo(1);
              this.xmlWorkspace = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace));
            },
            toggleMenu() {
                this.workspace.toolbox_.flyout_.scrollbar_.set(Math.random());

                emitResize();
            },
            changeBackgroundColor(color) {
                document.querySelector('.blocklyMainBackground').style.fill = color;
            },
            setXMLToWorkspace(xmlString) {
                this.workspace.clear();
                let xml = Blockly.Xml.textToDom(xmlString);
                Blockly.Xml.domToWorkspace(xml, this.workspace);
            },
            destroyJoystickNipples() {
                if (this.leftNipple) {
                    this.leftNipple.destroy();
                }

                if (this.rightNipple) {
                    this.rightNipple.destroy();
                }
            },
            initialiseJoystickNipples() {
                this.destroyJoystickNipples();

                const nippleSize = $(window).width() * 0.05;
                const nippleTopPosition = ($(window).width() * 0.299) + ($('.game-controller__panel').height() || 64);
                const nippleButtonSize = ($('.nipple-inside').width() || 100) * 0.92;
                const nippleButtonMargin = (-(nippleButtonSize / 2)).toFixed(2);
                const nippleStyleObject = {
                    height: `${nippleButtonSize}px`,
                    width: `${nippleButtonSize}px`,
                    'margin-left': `${nippleButtonMargin}px`,
                    'margin-top': `${nippleButtonMargin}px`,
                };

                this.leftNipple = window.nipplejs.create({
                    zone: document.getElementById('controller-nipple-left'),
                    size: nippleSize || 100,
                    mode: 'static',
                    position: {
                        top: `calc(${nippleTopPosition || 44}px + 1rem)`,
                        left: '37.9%',
                    },
                    lockX: !!this.isLeftNippleLocked,
                    lockY: !!this.isLeftNippleLocked,
                });

                this.leftNipple
                    .on('end', () => {
                        if (!this.isLeftNippleLocked) {
                            this.callJoystickAction({
                                buttonKey: 12,
                                action: 'released',
                            });
                        }
                    })
                    .on('move', (evt, data) => {
                        const degree = (data.angle && data.angle.degree) || 0;
                        const force = data.force || 0;

                        if (!this.isLeftNippleLocked) {
                            this.callJoystickAction({
                                buttonKey: 12,
                                degree,
                                force,
                                action: 'touched',
                            });
                        }
                    });

                $('#controller-nipple-left .nipple .front').css(nippleStyleObject);

                this.rightNipple = window.nipplejs.create({
                    zone: document.getElementById('controller-nipple-right'),
                    size: nippleSize || 100,
                    mode: 'static',
                    position: {
                        top: `calc(${nippleTopPosition || 44}px + 1rem)`,
                        right: '37.5%',
                    },
                    lockX: !!this.isRightNippleLocked,
                    lockY: !!this.isRightNippleLocked,
                });

                this.rightNipple
                    .on('end', () => {
                        if (!this.isRightNippleLocked) {
                            this.callJoystickAction({
                                buttonKey: 13,
                                action: 'released',
                            });
                        }
                    })
                    .on('move', (evt, data) => {
                        const degree = (data.angle && data.angle.degree) || 0;
                        const force = data.force || 0;

                        if (!this.isRightNippleLocked) {
                            this.callJoystickAction({
                                buttonKey: 13,
                                degree,
                                force,
                                action: 'touched',
                            });
                        }
                    });

                $('#controller-nipple-right .nipple .front').css(nippleStyleObject);
            },
            callJoystickButtonAction(buttonKey = 0, action) {
                this.callJoystickAction({
                    buttonKey,
                    action,
                });
            },
            callJoystickAction({ buttonKey = null, degree = null, force = null, action }) {
                if (
                    ![
                        'pressed',
                        'touched',
                        'released',
                    ].includes(action)
                ) {
                    return;
                }

                this.joyStickCurrentAction = `${buttonKey}, ${degree || ''} ${force || ''} ${action}`;
                console.log(this.joyStickCurrentAction);

                try {
                    window.invokeJoystickCSCode({
                        buttonKey,
                        degree,
                        force,
                        action,
                    });
                } catch (e) {
                    console.error(e.message);
                }
            },
            turnJoystickLightOn() {
                this.isLightIndicatorOn = true;
            },
            turnJoystickLightOff() {
                this.isLightIndicatorOn = false;
            },
            showJoystickIcon() {
                this.isShowJoyStickSidebarIcon = true;
            },
            hideJoystickIcon() {
                this.isShowJoyStickSidebarIcon = false;
            },
            lockJoystickLeftNipple() {
                this.isLeftNippleLocked = true;

                this.$nextTick(() => {
                    this.initialiseJoystickNipples();
                });
            },
            unlockJoystickLeftNipple() {
                this.isLeftNippleLocked = false;

                this.$nextTick(() => {
                    this.initialiseJoystickNipples();
                });
            },
            lockJoystickRightNipple() {
                this.isRightNippleLocked = true;

                this.$nextTick(() => {
                    this.initialiseJoystickNipples();
                });
            },
            unlockJoystickRightNipple() {
                this.isRightNippleLocked = false;

                this.$nextTick(() => {
                    this.initialiseJoystickNipples();
                });
            },
            async initWorkspace() {
                Blockly.HSV_SATURATION = 0.90;
                Blockly.HSV_VALUE = 0.92;
                const blocklyOptions = {
                    grid: {
                        spacing: 25,
                        length: 3,
                        colour: '#ccc',
                        snap: false,
                    },
                    rtl: this.authCurrentDirection === "rtl",
                    trashcan: true,
                    media: './static/media/',
                    toolbox: this.workspaceLevel[this.curentLevel - 1],
                    zoom: {
                        controls: true,
                        wheel: true,
                    },
                };

                if (window.$(window).width() <= 768) {
                    blocklyOptions.zoom.startScale = 0.5;
                }

                Blockly.BlockSvg.START_HAT = true;

                this.workspace = Blockly.inject(document.getElementById('blocks'), blocklyOptions);
                Blockly.Xml.domToWorkspace(Blockly.Xml.textToDom(this.startBlock), this.workspace);

                document.querySelector('.blocklyMainBackground').style.fill = '#2e2e2e';
                this.xmlWorkspace = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace));

                this.$nextTick(() => {
                    this.workspace.clearUndo();
                });

                this.workspace.addChangeListener(this.eventBlockly);

                if (/Android|Windows 7|iOS|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(this.browser.os)) {
                    document.querySelector('.code__edit-controls').style.bottom = '42px';
                }

                emitResize(300);

                if (this.$route.params.topicId !== undefined) {
                    try {
                        await this.$store.dispatch('topic/getTopic', {
                            id: this.$route.params.topicId,
                        });

                        if (this.topicTopic.programming_missions !== null && this.topicTopic.programming_missions.length !== 0) {
                            this.workspace.updateToolbox(this.topicTopic.programming_missions[0].content);
                            this.showLevels = false;
                        }
                    } catch (e) {
                        // Code
                    }
                }

                window.$('.blocklyFlyoutScrollbar').attr('display', 'none');

                $(window).resize(this.initialiseJoystickNipples);

                // this.initialiseJoystickNipples();
            },
        },
        async mounted() {
            if (this.authWorkspaceLanguageLoaded && !this.workspace) {
                this.initWorkspace();
            }
        },
        watch: {
            xmlWorkspace() {
                this.download = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace));
            },
            isJoyStick(value) {
                if (value) {
                    this.$nextTick(() => {
                        this.initialiseJoystickNipples();
                    });
                } else {
                    this.destroyJoystickNipples();
                }
            },
            authWorkspaceLanguageLoaded() {
                if (this.authWorkspaceLanguageLoaded && !this.workspace) {
                    this.initWorkspace();
                }
            },
        },
        beforeDestroy() {
            $(window).off('resize');

            this.destroyJoystickNipples();
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/Workspace.vue